import { SidebarMenuItem } from "../../Types/Layout.type";

export const menuList: SidebarMenuItem[] = [
  {
    title: "",
    items: [
      {
        title: "Dashboard",
        id: 1,
        icon: "iconly-Home icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMDashboard`,
        active: false,
        roles: [1],
      },
      {
        title: "Pipeline",
        id: 12,
        icon: "iconly-Filter icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMPipeline`,
        active: false,
        roles: [1],
      },
      {
        title: "Leads",
        id: 2,
        icon: "iconly-User2 icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/LeadsProperty`,
        active: false,
        roles: [1, 2, 3, 4, 5, 6],
      },
      // One task list. Task Property, Task Finance and Task RH were three copies of
      // the same 893 line page pointed at different filters; with Finance and Mortgage
      // Broking gone there is only one kind of follow up left, so there is one list.
      // Roles are the union of the three, so nobody loses the list they had.
      {
        title: "Tasks",
        id: 2,
        icon: "iconly-Star icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMTaskList`,
        active: false,
        roles: [1, 2, 6],
      },
      // {
      //   title: "Task - MMP",
      //   id: 22,
      //   icon: "iconly-Tick-Square icli",
      //   type: "main",
      //   path: `${process.env.PUBLIC_URL}/CRMTaskMMP`,
      //   active: false,
      //   roles: [1, 5],
      // },

      {
        title: "Prop Search",
        id: 4,
        icon: "iconly-Location icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMPropertySearch`,
        active: false,
        roles: [1, 2, 4],
      },
      {
        title: "Prop Builder",
        id: 5,
        icon: "iconly-Work icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMBuilders`,
        active: false,
        roles: [1],
      },
      {
        title: "Prop Suburb",
        id: 8,
        icon: "iconly-Map icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMSuburb`,
        active: false,
        roles: [1],
      },
      {
        title: "Admin",
        id: 39,
        icon: "iconly-Setting icli",
        type: "sub",
        active: false,
        roles: [1],
        children: [
          { title: "Our Fees", id: 40, type: "link", path: `${process.env.PUBLIC_URL}/CRMBilling`, active: false, roles: [1] },
          { title: "Lead Source", id: 41, type: "link", path: `${process.env.PUBLIC_URL}/CRMLeadSource`, active: false, roles: [1] },
          { title: "Robert Johns", id: 47, type: "link", path: `${process.env.PUBLIC_URL}/CRMRobert`, active: false, roles: [1] },
          { title: "Sequences", id: 42, type: "link", path: `${process.env.PUBLIC_URL}/CRMSequences`, active: false, roles: [1] },
          { title: "Sonia Reports", id: 43, type: "link", path: `${process.env.PUBLIC_URL}/CRMSoniaReports`, active: false, roles: [1] },
          { title: "Staff", id: 44, type: "link", path: `${process.env.PUBLIC_URL}/CRMStaff`, active: false, roles: [1] },
          { title: "Stages", id: 45, type: "link", path: `${process.env.PUBLIC_URL}/CRMStages`, active: false, roles: [1] },
          { title: "The Sender", id: 46, type: "link", path: `${process.env.PUBLIC_URL}/CRMSendControl`, active: false, roles: [1] },
        ],
      },
      //  Richard, 16 Oct 2026: the CRM shows the Property (IP client) business. Everything
      //  for mortgage brokers sits under this one menu at the bottom.
      {
        title: "Mortgage Brokers",
        id: 50,
        icon: "iconly-Profile icli",
        type: "sub",
        active: false,
        roles: [1, 2, 5, 6, 7],
        children: [
          { title: "Dashboard", id: 51, type: "link", path: `${process.env.PUBLIC_URL}/CRMDashboardMB`, active: false, roles: [1] },
          { title: "Pipeline", id: 52, type: "link", path: `${process.env.PUBLIC_URL}/CRMPipelineMB`, active: false, roles: [1] },
          { title: "Leads", id: 53, type: "link", path: `${process.env.PUBLIC_URL}/LeadsMB`, active: false, roles: [1, 2, 6] },
          { title: "Tasks", id: 54, type: "link", path: `${process.env.PUBLIC_URL}/CRMTaskListMB`, active: false, roles: [1, 2, 6] },
          { title: "MB Builder", id: 55, type: "link", path: `${process.env.PUBLIC_URL}/MBBuilder`, active: false, roles: [1, 2, 6] },
          { title: "MB Platform", id: 56, type: "link", path: `${process.env.PUBLIC_URL}/CRMOperatorMembers`, active: false, roles: [7] },
          { title: "MMP Calculator", id: 59, type: "link", path: `${process.env.PUBLIC_URL}/CRMHomeLoan`, active: false, roles: [1, 5, 6] },
        ],
      },
      //  Richard, 16 Oct 2026: lenders and loan products are their own business, below MB.
      {
        title: "Finance",
        id: 60,
        icon: "iconly-Bank icli",
        type: "sub",
        active: false,
        roles: [1],
        children: [
          { title: "Lenders", id: 61, type: "link", path: `${process.env.PUBLIC_URL}/CRMLenders`, active: false, roles: [1] },
          { title: "Loan Products", id: 62, type: "link", path: `${process.env.PUBLIC_URL}/CRMLoanProducts`, active: false, roles: [1] },
        ],
      },
    ],
  },
];